import http from '../../../../../libs/http'

const api = `${process.env.VUE_APP_MICROSERVICE_API_DASHBOARD}`

const costFilters = (query) => http.get(`${api}/operation-report/cost-client-filters`, { params: { ...query } })
const apiListCost = (query) => http.get(`${api}/gerencia/cost-list`, { params: { ...query } })
const apiListCostGastos = (query) => http.get(`${api}/gerencia/cost-list-gastos`, { params: { ...query } })
const apiListCostZonificacion = (query) => http.get(`${api}/gerencia/cost-list-zonificacion`, { params: { ...query } })
const apiListCostBodega = (query) => http.get(`${api}/gerencia/cost-list-bodega`, { params: { ...query } })
const apiListCostClientes = (query) => http.get(`${api}/operation-report/clientes-bodegas`, { params: { ...query } })
const apiAnalisisMedicamentosMes = (query) => http.get(`${api}/operation-report/analisis-medicamentos-mes`, { params: { ...query } })
const apiAnalisisMedProv = (query) => http.get(`${api}/operation-report/analisis-med-prov`, { params: { ...query } })

export {
  costFilters,
  apiListCost,
  apiListCostGastos,
  apiListCostZonificacion,
  apiListCostBodega,
  apiListCostClientes,
  apiAnalisisMedicamentosMes,
  apiAnalisisMedProv
}
